import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "liga-float-bar" }
const _hoisted_2 = { class: "liga-float-title-pill" }
const _hoisted_3 = { class: "liga-float-title-text" }
const _hoisted_4 = { class: "liga-float-title-sub" }
const _hoisted_5 = { class: "track-number" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "track-info" }
const _hoisted_8 = { class: "track-name" }
const _hoisted_9 = { class: "track-duration" }
const _hoisted_10 = { class: "track-actions" }
const _hoisted_11 = { class: "play-button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border events-page-header liga-float-header" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "release-music-float-toolbar" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("button", {
                  type: "button",
                  class: "liga-float-circle",
                  "aria-label": "Назад",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBackToHub && _ctx.goBackToHub(...args)))
                }, [
                  _createVNode(_component_ion_icon, { icon: _ctx.arrowBackOutline }, null, 8, ["icon"])
                ]),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.releaseEntity.programName || 'Музыка'), 1),
                  _createElementVNode("small", _hoisted_4, _toDisplayString(_ctx.headerSubtitle), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "liga-float-circle",
                  "aria-label": "На главную",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
                }, [
                  _createVNode(_component_ion_icon, { icon: _ctx.homeOutline }, null, 8, ["icon"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        class: "main-background release-music-content",
        fullscreen: true,
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, { class: "bg-transparent music-list" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_list, {
                class: "bg-transparent",
                lines: "none"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.musicList, (audioTrack, idx) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: idx,
                      onClick: ($event: any) => (_ctx.selectTrack(idx)),
                      class: _normalizeClass(["music-item", { 'playing': _ctx.isTrackRowActive(idx) }])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          (!_ctx.isTrackRowActive(idx))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(idx + 1), 1))
                            : (_openBlock(), _createBlock(_component_ion_icon, {
                                key: 1,
                                icon: _ctx.playerBar.playing ? _ctx.pause : _ctx.play,
                                class: "playing-icon"
                              }, null, 8, ["icon"]))
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.mediaUtils.getTrackName(audioTrack)), 1),
                          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.getTrackDuration(audioTrack)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          (audioTrack.isOffline)
                            ? (_openBlock(), _createBlock(_component_ion_icon, {
                                key: 0,
                                icon: _ctx.cloudDone,
                                class: "offline-icon"
                              }, null, 8, ["icon"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.isTrackRowActive(idx) && _ctx.playerBar.playing ? _ctx.pause : _ctx.play,
                              class: "play-icon"
                            }, null, 8, ["icon"])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onClick", "class"]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, {
                class: "fake-footer bg-transparent",
                lines: "none"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}